import React, { useContext, useRef } from 'react';
import { Pressable, View } from 'react-native';
import { Text, Icon } from '@rneui/themed';
import Cornerblock from '../cms/Cornerblock';
import { findActive } from '../../common/helpers/Navigation';
import { fetchPage } from '../../common/Api';
import AppContext from '../../contexts/App';
import Utils from '../../common/Utils';

const SecondaryNav = ({ followContentLink, cornerBlocksRef }) => {
    const { state, dispatch } = useContext(AppContext);
    const isCollapsed = state.navigation.primaryIsCollapsed;
    const path = state?.action?.href || window.location.pathname;
    const activeChild = useRef(findActive(path, 1));
    const isTertiaryVisible = state?.navigation?.tertiary && state?.navigation?.hasOwnProperty(activeChild.current);
    const cornerblockData = state?.action?.data?.page?.cornerBlock || state?.action?.data?.references?.[state?.action?.data?.page?.sourceKeys[0]];
    const cachedBlockData = cornerBlocksRef || { current: {} };

    if (!state?.navigation?.secondary || state?.action?.href?.equals('/')) {
        return null;
    }

    if (!cachedBlockData.current[path]) cachedBlockData.current[path] = JSON.stringify(cornerblockData);

    const activeSecondary = state?.navigation?.secondary[findActive(state?.action.href || window.location.pathname)];

    const renderMenuItem = (item, index) => {
        if (item.doNotIncludeInNavigation) {
            return null;
        }

        const handlePress = async e => {
            e.preventDefault();
            activeChild.current = item.urlName;

            await fetchPage(dispatch, item.rootPath);
        };

        const handleHover = (e, isIn) => {
            const target = e?.nativeEvent?.currentTarget;

            if (target) {
                target.style.backgroundColor = isIn ? 'rgba(107, 4, 16, 0.85)' : '#fff';
                // target.style.backgroundImage = isIn ? `url("${item.image.cdnImagePath}")` : undefined;

                const titleElement = target.children[0]?.children[0];

                if (titleElement) {
                    titleElement.style.color = isIn ? '#fff' : '#153d6e';
                }

                const iconElement = target.children[0].children[1].children[0].children[0].children[0];

                if (iconElement) {
                    iconElement.style.color = isIn ? '#fff' : '#153d6e';
                }
            }
        };

        const isActive = activeChild?.current?.equals(item.title?.toLowerCase());
        //background image:
        return (
            <Pressable
                key={item.id}
                onHoverIn={e => handleHover(e, true)}
                onHoverOut={e => handleHover(e, false)}
                onPress={e => handlePress(e)}
                style={{
                    backgroundColor: isActive ? '#6b0410' : '#fff',
                    borderBottomColor: '#dde4e9',
                    borderBottomWidth: 1,
                    borderTopColor: index === 0 ? '#dde4e9' : undefined,
                    borderTopWidth: index === 0 ? 1 : 0,
                    cursor: 'pointer',
                    flex: 1,
                    minHeight: 0,
                    minWidth: 0
                }}
            >
                <View
                    style={{
                        alignItems: 'center',
                        flex: 1,
                        width: 'auto',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}
                >
                    <Text
                        style={{
                            color: isActive ? '#fff' : '#153d6e',
                            fontFamily: 'GothamBook',
                            fontSize: 20,
                            marginLeft: 40
                        }}
                        numberOfLines={1}
                    >
                        {item.title}
                    </Text>
                    {!isTertiaryVisible && (
                        <Icon color='transparent' name='chevron-right-circle-outline' reverse={true} reverseColor={isActive ? '#fff' : '#153d6e'} type='material-community' />
                    )}
                </View>
            </Pressable>
        );
    };

    if (!activeSecondary) {
        return null;
    }

    const blockDataFromCache = JSON.parse(cachedBlockData.current[path]);
    const { key: cornerblockKey, rest: cornerblockProps } = Utils.splitKeyFromProps(blockDataFromCache);

    return (
        <View
            style={{
                borderRightColor: isCollapsed ? '#8897a2' : undefined,
                borderRightWidth: isCollapsed ? 0.7 : 0,
                flex: 1,
                flexShrink: 1,
                overflowY: 'hidden',
                width: '100%'
            }}
        >
            <View style={{ flexGrow: 1 }}>{activeSecondary.map((item, index) => renderMenuItem(item, index))}</View>
            {blockDataFromCache && (
                <View style={{ flexGrow: 1 }}>
                    <Cornerblock
                        key={cornerblockKey}
                        {...cornerblockProps}
                        followContentLink={followContentLink}
                        renderSingle={isCollapsed}
                        width='100%' //{isCollapsed ? '100%' : width}
                    />
                </View>
            )}
        </View>
    );
};

export default SecondaryNav;
